import React, { useState, useEffect, useContext } from 'react';
import axios from 'axios';
import '../../../assests/css/admin/SubAdminManagement/SubAdminManagement.css';
import { AppContext } from '../../../context/Appcontext';
import Adminmasterlayout from '../../../layouts/Adminmasterlayout/Adminmasterlayout';

const SubAdminAdd = ({ onBack, onSave }) => {
  const { baseUrl, regExpChecker } = useContext(AppContext);
  const [firstname, setfirstname] = useState('');
  const [lastname, setlastname] = useState('');
  const [password, setPassword] = useState('');
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');
  const [role, setrole] = useState('');
  const [department, setDepartment] = useState('');
  const [status, setStatus] = useState('');
  const [departments, setdepartments] = useState({});

  const validateForm = () => {
    let newdepartments = {};
    const firstnameErr = regExpChecker('firstname', firstname);
    if (firstnameErr) newdepartments.firstname = firstnameErr;
    const lastnameErr = regExpChecker('lastname', lastname);
    if (lastnameErr) newdepartments.lastname = lastnameErr;
    const emailErr = regExpChecker('email', email);
    if (emailErr) newdepartments.email = emailErr;
    const roleErr = regExpChecker('role', role);
    if (roleErr) newdepartments.role = roleErr;
    setdepartments(newdepartments);
    return Object.keys(newdepartments).length === 0;
  };

  const createSubAdmin = () => {
    const formData = new FormData();
    formData.append('firstName', firstname);
    formData.append('lastName', lastname);
    formData.append('password', password);
    formData.append('email', email);
    formData.append('phone', phone);
    formData.append('ngdepartment_id', department);
    formData.append('status', status);
    formData.append('role', role);
    axios.post(`${baseUrl}/admin/subadmin/createSubAdmin`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
      .then((response) => {
        console.log(response.data);
        alert(response.data.message);
        if (onSave) onSave();
        if (onBack) onBack();
      })
      .catch((error) => {
        console.log(error);
        alert(error?.response?.data?.message || 'Something went wrong');
      });
  };

  const handleSubmit = () => {
    if (!validateForm()) return;
    createSubAdmin();
  };

  return (
    <div className="sam-wrapper">
      <div className="sam-container">
        <button className="sam-back-link" onClick={onBack}>
          &#8592; Back to List
        </button>
        <div className="sam-card">
          <div className="sam-page-header">
            <h2 className="sam-page-title">Add SubAdmin</h2>
            <p className="sam-page-subtitle">Fill in the details to create a new sub-admin account.</p>
          </div>
          <hr className="sam-divider" />
          <div className="sam-form">
            <div className="sam-form-row-2">
              <div className="sam-form-group">
                <label className="sam-label">First Name</label>
                <input
                  className="sam-input"
                  type="text"
                  value={firstname}
                  onChange={(e) => setfirstname(e.target.value)}
                  placeholder="Enter first name"
                />
                {departments.firstname && (
                  <p className="sam-error">{departments.firstname}</p>
                )}
              </div>
              <div className="sam-form-group">
                <label className="sam-label">Last Name</label>
                <input
                  className="sam-input"
                  type="text"
                  value={lastname}
                  onChange={(e) => setlastname(e.target.value)}
                  placeholder="Enter last name"
                />
                {departments.lastname && (
                  <p className="sam-error">{departments.lastname}</p>
                )}
              </div>
            </div>
            <div className="sam-form-group">
              <label className="sam-label">Password</label>
              <input
                className="sam-input"
                type="text"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Enter Password"
              />
              {departments.password && (
                <p className="sam-error">{departments.password}</p>
              )}
            </div>
            <div className="sam-form-group">
              <label className="sam-label">Email</label>
              <input
                className="sam-input"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Enter email address"
              />
              {departments.email && (
                <p className="sam-error">{departments.email}</p>
              )}
            </div>
            <div className="sam-form-group">
              <label className="sam-label">Phone</label>
              <input
                className="sam-input"
                type="text"
                value={phone}
                onChange={(e) => setPhone(e.target.value)}
                placeholder="Enter phone number"
              />
            </div>
            <div className="sam-form-group">
              <label className="sam-label">Role</label>
              <input
                className="sam-input"
                type="text"
                value={role}
                onChange={(e) => setrole(e.target.value)}
                placeholder="Enter role"
              />
              {departments.role && (
                <p className="sam-error">{departments.role}</p>
              )}
            </div>
            <div className="sam-form-actions">
              <button className="sam-btn sam-btn-primary" onClick={handleSubmit}>
                Create SubAdmin
              </button>
              <button className="sam-btn sam-btn-secondary" onClick={onBack}>
                Cancel
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const SubAdminEdit = ({ admin, onBack, onSave }) => {
  const { baseUrl } = useContext(AppContext);

  const [firstname, setfirstname] = useState(admin?.firstName || '');
  const [lastname, setlastname] = useState(admin?.lastName || '');
  const [password, setPassword] = useState(admin?.password || '');
  const [email, setEmail] = useState(admin?.email || '');
  const [phone, setPhone] = useState(admin?.phone || '');
  const [role, setrole] = useState('');

  const updateSubAdmin = () => {
    const formData = new FormData();
    formData.append('firstName', firstname);
    formData.append('lastName', lastname);
    formData.append('password', password);
    formData.append('email', email);
    formData.append('phone', phone);
    if (role) {
      formData.append('role', role);
    }
    axios.post(`${baseUrl}/admin/subadmin/updateSubAdmin/${admin.id}`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
      .then((response) => {
        console.log(response.data);
        console.log(response.data.error.message);
        alert(response.data.message);
        if (onSave) onSave();
        if (onBack) onBack();
      })
      .catch((error) => {
        console.log(error);
        alert(error?.response?.data?.message || 'Something went wrong');
      });
  };

  return (
    <div className="sam-wrapper">
      <div className="sam-container">
        <button className="sam-back-link" onClick={onBack}>
          &#8592; Back to List
        </button>
        <div className="sam-card">
          <div className="sam-page-header">
            <h2 className="sam-page-title">Edit SubAdmin</h2>
            <p className="sam-page-subtitle">Update the details for this sub-admin account.</p>
          </div>
          <hr className="sam-divider" />
          <div className="sam-form">
            <div className="sam-form-row-2">
              <div className="sam-form-group">
                <label className="sam-label">First Name</label>
                <input
                  className="sam-input"
                  type="text"
                  value={lastname}
                  onChange={(e) => setlastname(e.target.value)}
                  placeholder="Enter first name"
                />
              </div>
              <div className="sam-form-group">
                <label className="sam-label">Last Name</label>
                <input
                  className="sam-input"
                  type="text"
                  value={lastname}
                  onChange={(e) => setlastname(e.target.value)}
                  placeholder="Enter last name"
                />
              </div>
            </div>
            <div className="sam-form-group">
              <label className="sam-label">Password</label>
              <input
                className="sam-input"
                type="text"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Enter password"
              />
            </div>
            <div className="sam-form-group">
              <label className="sam-label">Email</label>
              <input
                className="sam-input"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Enter email address"
              />
            </div>
            <div className="sam-form-group">
              <label className="sam-label">Phone</label>
              <input
                className="sam-input"
                type="text"
                value={phone}
                onChange={(e) => setPhone(e.target.value)}
                placeholder="Enter phone number"
              />
            </div>
            <div className="sam-form-group">
              <label className="sam-label">Role</label>
              <input
                className="sam-input"
                type="text"
                value={role}
                onChange={(e) => setrole(e.target.value)}
                placeholder="Enter new role (leave blank to keep current)"
              />
            </div>
            <div className="sam-form-actions">
              <button className="sam-btn sam-btn-primary" onClick={updateSubAdmin}>
                Update SubAdmin
              </button>
              <button className="sam-btn sam-btn-secondary" onClick={onBack}>
                Cancel
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const SubAdminList = ({ onEdit, onAdd }) => {
  const { baseUrl } = useContext(AppContext);
  const [subAdmins, setSubAdmins] = useState([]);

  const viewAllSubAdmins = () => {
    axios.get(`${baseUrl}/admin/subadmin/viewAllSubAdmins`)
      .then((response) => {
        console.log(response.data);
        if (response.data.success) {
          setSubAdmins(response.data.data);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  useEffect(() => {
    viewAllSubAdmins();
  }, []);

  const deleteSubAdmin = (id) => {
    const formData = new FormData();
    formData.append('id', id);
    axios.post(`${baseUrl}/admin/subadmin/deleteSubAdmin`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
      .then((response) => {
        console.log(response.data);
        alert(response.data.message);
        viewAllSubAdmins();
      })
      .catch((error) => {
        console.log(error);
      });
  };

  return (
    <div className="sam-wrapper">
      <div className="sam-container">
        <div className="sam-card">
          <div className="sam-flex-between sam-page-header">
            <div>
              <h2 className="sam-page-title">SubAdmin List</h2>
              <p className="sam-page-subtitle">Manage all sub-administrator accounts.</p>
            </div>
            <button className="sam-btn sam-btn-primary" onClick={onAdd}>
              + Add SubAdmin
            </button>
          </div>
          <hr className="sam-divider" />
          <div className="sam-table-wrapper">
            <table className="sam-table">
              <thead>
                <tr>
                  <th>ID</th>
                  <th>First Name</th>
                  <th>Last Name</th>
                  <th>Email</th>
                  <th>Phone</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {subAdmins.length === 0 ? (
                  <tr>
                    <td colSpan={6} className="sam-empty">No sub-admins found.</td>
                  </tr>
                ) : (
                  subAdmins.map((admin) => (
                    <tr key={admin.id}>
                      <td><span className="sam-id-badge">{admin.id}</span></td>
                      <td>{admin.firstName}</td>
                      <td>{admin.lastName}</td>
                      <td>{admin.email}</td>
                      <td>{admin.phone}</td>
                      <td>
                        <div className="sam-table-actions">
                          <button className="sam-btn sam-btn-edit" onClick={() => onEdit(admin)}>
                            Edit
                          </button>
                          <button
                            className="sam-btn sam-btn-danger"
                            onClick={() => deleteSubAdmin(admin.id)}
                          >
                            Delete
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

const SubAdminManagement = () => {
  const [currentView, setCurrentView] = useState('list');
  const [selectedAdmin, setSelectedAdmin] = useState(null);

  const handleAdd = () => {
    setCurrentView('add');
  };

  const handleEdit = (admin) => {
    setSelectedAdmin(admin);
    setCurrentView('edit');
  };

  const handleBack = () => {
    setCurrentView('list');
    setSelectedAdmin(null);
  };

  return (
    <Adminmasterlayout>
      <div>
        {currentView === 'list' && (
          <SubAdminList
            onAdd={handleAdd}
            onEdit={handleEdit}
          />
        )}
        {currentView === 'add' && (
          <SubAdminAdd
            onBack={handleBack}
            onSave={handleBack}
          />
        )}
        {currentView === 'edit' && (
          <SubAdminEdit
            admin={selectedAdmin}
            onBack={handleBack}
            onSave={handleBack}
          />
        )}
      </div>
    </Adminmasterlayout>
  );
};

export default SubAdminManagement;